import {CultureHouseElement} from '../../culture/dashboard/types/CultureHouseTypes';

export type AppendixPageConfig = {
  pillarKey: string;
  pageTitle: string;
  startIndex?: number;
  endIndex?: number;
  pagePart?: 1 | 2;
};

export const appendixPageConfigs: AppendixPageConfig[] = [
  {
    pillarKey: 'development_and_communication',
    pageTitle: 'analysisGuide.culturePillars.pageTwo.developmentCommunication.title',
    endIndex: 4,
  },
  {
    pillarKey: 'interaction_and_empathy',
    pageTitle: 'analysisGuide.culturePillars.pageTwo.interactionEmpathy.title',
    endIndex: 4,
  },
  {
    pillarKey: 'leadership_and_team',
    pageTitle: 'analysisGuide.culturePillars.pageTwo.leadershipTeam.title',
    endIndex: 4,
    pagePart: 1,
  },
  {
    pillarKey: 'leadership_and_team',
    pageTitle: 'analysisGuide.culturePillars.pageTwo.leadershipTeam.title',
    startIndex: 4,
    endIndex: 8,
    pagePart: 2,
  },
  {
    pillarKey: 'purpose_and_value',
    pageTitle: 'analysisGuide.culturePillars.pageOne.purposeValues.title',
    endIndex: 4,
    pagePart: 1,
  },
  {
    pillarKey: 'purpose_and_value',
    pageTitle: 'analysisGuide.culturePillars.pageOne.purposeValues.title',
    startIndex: 4,
    endIndex: 8,
    pagePart: 2,
  },
  {
    pillarKey: 'appearance_and_risk',
    pageTitle: 'analysisGuide.culturePillars.pageOne.appearanceRisk.title',
    endIndex: 4,
    pagePart: 1,
  },
  {
    pillarKey: 'appearance_and_risk',
    pageTitle: 'analysisGuide.culturePillars.pageOne.appearanceRisk.title',
    startIndex: 4,
    endIndex: 8,
    pagePart: 2,
  },
  {
    pillarKey: 'innovation_and_convention',
    pageTitle: 'analysisGuide.culturePillars.pageOne.innovationConvention.title',
    endIndex: 4,
    pagePart: 1,
  },
  {
    pillarKey: 'innovation_and_convention',
    pageTitle: 'analysisGuide.culturePillars.pageOne.innovationConvention.title',
    startIndex: 4,
    endIndex: 8,
    pagePart: 2,
  },
  {
    pillarKey: 'new_work_and_hybrid_work',
    pageTitle: 'analysisGuide.culturePillars.pageTwo.newWorkHybridWork.title',
    endIndex: 4,
    pagePart: 1,
  },
  {
    pillarKey: 'new_work_and_hybrid_work',
    pageTitle: 'analysisGuide.culturePillars.pageTwo.newWorkHybridWork.title',
    startIndex: 4,
    endIndex: 8,
    pagePart: 2,
  },
  {
    pillarKey: 'performance_and_organization',
    pageTitle: 'analysisGuide.culturePillars.pageOne.performanceOrganisation.title',
    endIndex: 4,
    pagePart: 1,
  },
  {
    pillarKey: 'performance_and_organization',
    pageTitle: 'analysisGuide.culturePillars.pageOne.performanceOrganisation.title',
    startIndex: 4,
    endIndex: 8,
    pagePart: 2,
  },
];

export const getAppendixPageQuestions = (
  cultureHouse: CultureHouseElement[],
  config: AppendixPageConfig
) => {
  const pillarData = cultureHouse.find((item) => item.key === config.pillarKey);
  const allQuestions = pillarData?.surveyResults?.questions ?? [];
  const startIndex = config.startIndex ?? 0;

  if (config.endIndex === undefined) {
    return {pillarData, allQuestions, pillarQuestions: allQuestions.slice(startIndex)};
  }

  return {
    pillarData,
    allQuestions,
    pillarQuestions: allQuestions.slice(startIndex, config.endIndex),
  };
};

export const getVisibleAppendixPageConfigs = (cultureHouse: CultureHouseElement[]) => {
  return appendixPageConfigs.filter((config) => {
    const {pillarData, pillarQuestions} = getAppendixPageQuestions(cultureHouse, config);
    return Boolean(pillarData?.surveyResults) && pillarQuestions.length > 0;
  });
};
